(function($) {
    var $fn = $(".comp_partners");

    if ($fn.length) {
        $fn.find("[data-slider]").slick({
            infinite: false,
            slidesToShow: 8,
            slidesToScroll: 1,
            speed: 500,
            pauseOnHover: true,
            arrows: false,
            prevArrow: '<button type="button" class="part_ui_btn part_ui_btn_outline mod--circle slick-prev"><i class="icon--chevron-left"></i></button>',
            nextArrow: '<button type="button" class="part_ui_btn part_ui_btn_outline mod--circle slick-next"><i class="icon--chevron-right"></i></button>',
            dots: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1439,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }
})(jQuery);